import(/* webpackMode: "eager" */ "/workspace/apps/ssv-home/src/app/design-guidelines/page.tsx");
